<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Consumption') }}</h4>
        </div>
      </div>
    </div>

    <div class="vflex-row-0 pt-3">
      <ul class="nav nav-tabs">
        <li class="nav-item pl-3">
          <router-link
            class="nav-link"
            :class="{active: modelType === 'parse-resume'}"
            to="/billing/consumption">
            {{ $t('Parse resume') }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{active: modelType === 'invite-intervideo'}"
            to="/billing/consumption/invite-intervideo">
            {{ $t('Video interview invitation') }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{active: modelType === 'meetinsight-transcription'}"
            to="/billing/consumption/meetinsight-transcription">
            {{ $t('Meeting transcription/analysis') }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{active: modelType === 'invite-intervoice'}"
            to="/billing/consumption/invite-intervoice">
            {{ $t('Voice interview invitation') }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{active: modelType === 'seeker-profile'}"
            to="/billing/consumption/seeker-profile">
            {{ $t('Seeker profile') }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{active: modelType === 'invite-questionnaire-qca'}"
            to="/billing/consumption/invite-questionnaire-qca">
            {{ $t('Questionnaire QCA') }}
          </router-link>
        </li>
        <!--<li class="nav-item">
          <router-link
            class="nav-link"
            :class="{active: modelType === 'generative-text'}"
            to="/billing/consumption/generative-text">
            {{ $t('ChatGPT') }}
          </router-link>
        </li>-->
      </ul>
    </div>

    <router-view></router-view>

  </div>

</template>

<script>
export default {
  name: 'Consumption',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    modelType () {
      return this.$route.params.type || 'parse-resume'
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BillingConsumption/BillingConsumption.vue